// extracted by mini-css-extract-plugin
module.exports = {"overlay-class":"_1dG-BcZK","overlayClass":"_1dG-BcZK","menu-class":"_1c21QroY","menuClass":"_1c21QroY"};